/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-16 11:17:41
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-11-04 15:34:57
 * @LastEditTime: 2021-11-04 15:20:46
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/RecipientInfo/Modal.tsx
 */
import React from 'react';
import css from './css.module.less';
import { Modal, ModalFooter } from 'src/components/Antd';

import { Types as Name, dict } from './index';
import { OriCheckbox as Checkbox } from 'src/components/Antd/Checkbox/Checkbox';
import { get } from 'lodash';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Group = Checkbox.Group;
//import { useAfterDidMountEffect } from 'src/tools/customHooks';

const defaultState = {
  required: false,
  otpRequired: false,
  regex: '',
};

const _Checkbox = (props) => {
  const { children, className, ...rest } = props;
  return (
    <Checkbox className={`${css.checkbox} ${className || ''}`} {...rest}>
      {children}
    </Checkbox>
  );
};

const FieldModal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //问一下没有好i 是不是能disable
  const { availableFields = [], data: fields, onOk, onCancel, visible } = props;

  const [category, setCategory] = React.useState(
    (fields || []).reduce((pre, i) => {
      const v = get(i, 'name');
      if (v) {
        return [...pre, v];
      } else {
        return pre;
      }
    }, []),
  );

  const options = React.useMemo(() => {
    const hasFullName = category.find((i) => i === Name.FullName);
    const hasSepeatedNames = category.find((i) => {
      return i === Name.FirstName || i === Name.LastName;
    });

    return availableFields.map((i) => {
      //console.log('i', i);
      const { name, disabled } = i;
      const isSepearte = [Name.FirstName, Name.LastName].includes(name);
      const isFullName = i.name === Name.FullName;
      const dN = get(dict, `${name}.displayName`);

      if (disabled) {
        return (
          <_Checkbox value={name} key={name} disabled={true}>
            {dN}
          </_Checkbox>
        );
      } else {
        if ((hasFullName && isSepearte) || (isFullName && hasSepeatedNames)) {
          return (
            <_Checkbox value={name} key={name} disabled={true}>
              {dN}
            </_Checkbox>
          );
        } else {
          return (
            <_Checkbox value={name} key={name}>
              {dN}
            </_Checkbox>
          );
        }
      }
    });
  }, [availableFields, category]);

  const handleOnChange = (e) => {
    setCategory(e);
  };

  const onOkPress = () => {
    const mappedOriSort = (fields || []).reduce((pre, now) => {
      const { name } = now;
      return { ...pre, [name]: now };
    }, {});

    const _data = category.map((i) => {
      if (mappedOriSort[i]) {
        return mappedOriSort[i];
      } else {
        return { name: i, ...defaultState };
      }
    });

    if (onOk) {
      onOk(_data);
    }
  };

  return (
    <Modal
      visible={visible}
      title={getI18n('salesChannelCheckout.index.selectRecipientInformation')}
      onCancel={onCancel}>
      <div className={css.modalContainer}>
        <Group value={category} onChange={handleOnChange} className={css.group}>
          {options}
        </Group>
      </div>
      <ModalFooter
        okText={getI18nFromGeneral('general.antd.Modal.ModalFooter.confirm')}
        cancelText={getI18nFromGeneral('general.commonHeader.discard_text')}
        onOk={onOkPress}
        onCancel={onCancel}
        // hideOkButton={!category || (isDob && !(date.y || date.m || date.d))}
      />
    </Modal>
  );
};
export default FieldModal;
